module.exports = __webpack_public_path__ + "static/media/afl-everyday-digital-Weekend-Papers-v2.38a3c677.png";